import React, { useState, useEffect } from 'react'
import YouTube from 'react-youtube';
import useMobile from '../../../hooks/useMobile';
import './preview-youtube.scss';


const PreviewYoutube = props => {
    const { info } = props;

    const [idVideo, setIdVideo] = useState(null)
    const [isReady, setIsReady] = useState(false)

    const [optionsVideo, setOptionsVideo ] = useState({
        width: '100%',
        height: '100%'
    });
    
    useEffect(()=>{
        if (!isReady) return

        const height = document.querySelector('.swiper-wrapper').clientHeight
        setOptionsVideo({
            width: '100%',
            height 
        })
    }, [isReady])

    useEffect(() => {
        if(info){
            if(info.includes('youtube.com')){
                var id = info.split('=')[1].split('&')[0];
                setIdVideo( id )
            }else
            if(info.includes('youtu.be')){
                var id = info.split('/')[3].split('?')[0];
                setIdVideo( id );
            }
        }
    }, [])

    return (
        <div className="o-preview-youtube">
            {
                idVideo &&
                <YouTube 
                    videoId={ idVideo }
                    opts={ optionsVideo }
                    onReady={()=> setIsReady(true)}
                />
            }
        </div>
    )
}

export default PreviewYoutube
